import { API_URL_ROOT } from "src/constants";

export const getFileUrl = (fileUrl?: string) => {
  if (typeof fileUrl !== "string" || fileUrl.startsWith("http")) return fileUrl;
  const url = new URL(fileUrl, API_URL_ROOT);
  return url.toString();
};
